export default __webpack_public_path__ + "static/logo-bcbsri-9a4b8b4a2fe219ec5e7173668828b06a.svg";